// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"227":"eb1d433e","232":"bb80746b","237":"4ce9ab1d","357":"fee37a3f","526":"b808d1e4","753":"6a90cc22","787":"9e9f4ffd","854":"e7652a10","872":"846df1f2"}[chunkId] + ".chunk.js";
};